import React, { useEffect, useState } from 'react'
import { SidePanelFooter } from 'Components/SidePanel';
import { useIntl } from 'react-intl';
import { Button, Checkbox, Icons, Loading, SearchInput, Tooltip } from '@gpstrackit/gtc-react-controls';
import './styles.scss'
import { UploadLayer } from './uploadLayer';
import { DeleteLayer } from './deleteLayer';
import { useDispatch, useSelector } from 'react-redux';
import { getListFile, reset } from '../../redux/slice';
import { NotificationManager } from "Components/Notifications";
import { savePreference } from 'Redux/actions';
import { LoadLayersOnTheMap, searchLayerOnTheMap } from '../../utils';
import { ItemLayer } from './itemLayer';
import { TypeObjectMap } from '../../../../../../../components/Map/providers/enums';

import { getPresignedUrlForKmzLayer } from '../../redux/slice';


const LayerKmz = ({
    handleView,
    mapRef
}) => {
    const { messages } = useIntl()
    const dispatch = useDispatch()

    const {
        files,
        loading,
        loadingDeleteLayer,
        statusDeleteLayer,
        responseCreateFiles, 
        loadingCreateFile
    } = useSelector(state => state.filesRedux);
    const { preferencesUser, loadingPreference } = useSelector(state => state.preferencesRedux);
    const { authenticatedId, user } = useSelector(state => state.securityRedux);
    const presignedUrlsResponse = useSelector(state => state.filesRedux.presignedUrlsResponse);

    const [checked, setChecked] = useState(false)
    const [addLayerModal, setAddLayerModal] = useState(false)
    const [deleteLayerModal, setDeleteLayerModal] = useState(false)
    const [onSearch, setOnSearch] = useState('')
    const [showItems, setShowItems] = useState([])
    const [selectedItems, setSelectedItems] = useState([])
    const [data, setData] = useState([])

    useEffect(() => {
        clearValues()
    }, [])

    useEffect(() => {
        if (files?.length === 0) { setData([]) }
        if (files?.length && !loading && preferencesUser?.length) {
            setData(files)
        }
    }, [files, loading, loadingPreference])

    useEffect(() => {
        getPreferencesData()
        setSelectedItems([])
    }, [data])

    useEffect(() => {
        if (responseCreateFiles?.length && !loadingCreateFile) {
            setData([...data, ...responseCreateFiles])
        }
    }, [responseCreateFiles, loadingCreateFile])

    useEffect(() => {
        if (statusDeleteLayer && !loadingDeleteLayer) {
            setSelectedItems([])
            setData([])
            clearValues()
            if (onSearch?.length > 0) {
                setOnSearch('')
            } else {
                setTimeout(() => {
                    dispatch(getListFile({
                        entityName: "KMZ"
                    }))
                }, "1000");

            }
        }
    }, [loadingDeleteLayer, statusDeleteLayer])

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            dispatch(getListFile({
                entityName: "KMZ",
                originalName: onSearch
            }))
        }, 1000);
        return () => clearTimeout(timeoutId);
    }, [onSearch, 1000]);

    useEffect(() => {
        if (showItems?.length === 10) {
            return NotificationManager.warning(
                messages['realtimemaps_layer_map_layer_maxShowMessage'],
                messages['realtimemaps_layer_map_layer_warning'],
                3000,
                null,
                null,
                'warning',
                null
            );
        }
    }, [showItems])

    const clearValues = () => {
        dispatch(reset({ files: [], loading: false }))
    }

    const searchItemInPreferences = (item) => {
        let key = user?.companyId
        if(user?.isSubUser){
            key = user?.subUserId
        }
        let flag = false
        const getShowedItems = preferencesUser?.find(item => item?.preferenceKey === 'layers')
        if(!getShowedItems) return flag
        const parseValues = JSON.parse(getShowedItems?.preferenceValue)
        const existValue = parseValues[key]?.find(value => value?.id === item?.id)
        if(existValue) flag = true
        return flag
    }

    const getPreferencesData = () => {
        let key = user?.companyId
        if(user?.isSubUser){
            key = user?.subUserId
        }
        const tempData = []
        const getShowedItems = preferencesUser?.find(item => item?.preferenceKey === 'layers')
        if(!getShowedItems) return
        const parseValues = JSON.parse(getShowedItems?.preferenceValue)

        data?.map(item => {
            parseValues[key]?.map(value => {
                if (item?.id === value?.id) {
                    return tempData.push(value)
                }
            })
        })
        setShowItems(tempData)
        dispatch(getPresignedUrlForKmzLayer(tempData));
    }


    const clearPreferenceData = () => {
        let key = user?.companyId
        if(user?.isSubUser){
            key = user?.subUserId
        }
        const tempData = []
        const getShowedItems = preferencesUser?.find(item => item?.preferenceKey === 'layers')
        const parseValues = JSON.parse(getShowedItems?.preferenceValue)
        parseValues[key]?.map(value => {
            const existValue = data?.find(item => value?.id === item?.id)
            if (existValue) tempData?.push(value)
        })
        saveInPreferences(tempData)
    }

    const selectedItem = (item, status) => {
        if (status) {
            setSelectedItems([...selectedItems, item])
        } else {
            const filterItems = selectedItems?.filter(previous => previous?.id !== item?.id)
            setSelectedItems(filterItems)
        }
    }

    const showItem = (status, item) => {
        if (status) {
            saveInPreferences([...showItems, item])
            setShowItems([...showItems, item])
        } else {
            const filterItems = showItems?.filter(previous => previous?.id !== item?.id)
            saveInPreferences(filterItems)
            setShowItems(filterItems)

            //remove the layer from the map
            mapRef.current.removeMapObject(`kmzLayer_${item.id}`, TypeObjectMap.LayerKmz);
        }
    }

    const validateExistName = (newFiles) => {
        let flag = true
        data?.map(item => {
            const search = newFiles?.find(file => file?.originalName.toLowerCase() === item?.originalName?.split(".")[0]?.toLowerCase())
            if(search) return flag = false
        })

        return flag
    }

    const disabledSwitch = (item) => {
        let flag = false
        const filterItem = showItems?.find(previous => previous?.id === item?.id)
        if (!filterItem && showItems?.length >= 10) flag = true
        return flag
    }

    const saveInPreferences = (data = []) => {
        let key = user?.companyId
        if(user?.isSubUser){
            key = user?.subUserId
        }
        const saveData = {[key]: data}
        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey:  "layers", preferenceValue: saveData}));

        //We need to update the layers on the map
        const tempData = []
        presignedUrlsResponse?.length > 0 && tempData.push(...presignedUrlsResponse)
        data?.map(item => {
            const existValue = presignedUrlsResponse?.find(value => value?.id === item?.id)
            if(!existValue) tempData?.push(item)
        }) 

        //Adding new layers to the map
        dispatch(getPresignedUrlForKmzLayer(tempData));
    }

    return (
        <div>
            <SearchInput
                onSearchText={(text) => setOnSearch(text)}
                searchText={onSearch}
                placeholder={messages['search']}
            />
            <div className='container_icons_layerKmz'>
                <div style={{
                    marginRight: '10px'
                }}>
                    <Checkbox checked={checked} onChange={(status) => {
                        if (status) {
                            setSelectedItems(data)
                        } else {
                            setSelectedItems([])
                        }
                        setChecked(status)
                    }} />
                </div>
                <div>
                    <Tooltip title={messages['add']}>
                        <Icons size='medium' onClick={() => setAddLayerModal(true)} style={{ cursor: 'pointer', marginLeft: '-8px', marginRight: '10px', marginTop: '4px' }} name='add_box' />
                    </Tooltip>
                </div>
                {
                    selectedItems?.length > 0 && 
                    <div>
                        <Tooltip title={messages['delete']}>
                            <Icons size='medium' onClick={() => setDeleteLayerModal(true)} style={{ cursor: 'pointer', marginTop: '4px' }} name='delete' />
                        </Tooltip>
                    </div>
                }
            </div>

            <div className='list_layerKmz'>
                { loading /* || loadingPreference  */
                    ?
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Loading /></div>
                    :
                        data?.map(item => {
                            return(
                                <ItemLayer
                                    item={item}
                                    data={data}
                                    setData={setData}
                                    selectedItem={selectedItem}
                                    selectedItems={selectedItems}
                                    searchItemInPreferences={searchItemInPreferences}
                                    searchLayerOnTheMap={searchLayerOnTheMap}
                                    mapRef={mapRef}
                                    disabledSwitch={disabledSwitch}
                                    showItem={showItem}
                                    showItems={showItems}
                                />
                        )}) 
                }
            </div>

            <div style={{padding: '2px', position: 'absolute', bottom: '120px', width: '85%', background: 'white'}}>
                <Button
                    variant='secondary'
                    onClick={() => {
                        clearPreferenceData()
                        clearValues()
                        handleView(0);
                    }}
                >
                    {messages['realtimemaps_layer_map_back']}
                </Button>
            </div>

            <UploadLayer
                isOpenModal={addLayerModal}
                setIsModalOpen={setAddLayerModal}
                validateExistName={validateExistName}
            />

            <DeleteLayer
                items={selectedItems}
                isOpenModal={deleteLayerModal}
                setIsModalOpen={setDeleteLayerModal}
            />
        </div>
    )
}

export default LayerKmz